import { useCMSDocument } from "@with-nx/hooks-n-helpers";
import { useServerRegion } from "@with-nx/region";
import { Rule } from "@with-nx/simple-ui/atoms";
import { useRouter } from "next/router";
import { useState } from "react";
import { Box } from "simple-effing-primitive-layout";

const ITEMS: {
  label: string;
  slug: string;
}[] = [
  {
    slug: "cancellation-policy",
    label: "Cancellation Policy",
  },
  {
    slug: "code-of-conduct",
    label: "Code of Conduct",
  },
  {
    slug: "cookie-policy",
    label: "Cookie Policy",
  },
  {
    slug: "copyright",
    label: "Copyright",
  },
  {
    slug: "eula",
    label: "EULA",
  },
  {
    slug: "hardware-rental-agreement",
    label: "Hardware Rental Agreement",
  },
  {
    slug: "payment",
    label: "Payment Agreement",
  },
  {
    slug: "privacy-policy",
    label: "Privacy Policy",
  },
  {
    slug: "projector-rental-policy",
    label: "Projector Rental Policy",
  },
  {
    slug: "submissions",
    label: "Submissions",
  },
  {
    slug: "support-policy",
    label: "Support Policy",
  },
  {
    slug: "terms-and-conditions",
    label: "Terms and Conditions",
  },
];

export const LegalMenuPlainItem = ({
  i,
  active,
  label,
  href,
}: {
  i: number;
  active?: boolean;
  label: string;
  href: string;
}) => {
  const [hover, _hover] = useState(false);

  return (
    <a
      href={href}
      onMouseEnter={() => _hover(true)}
      onMouseLeave={() => _hover(false)}
      rel="nofollow"
    >
      <Box
        top={i === 0 ? 0 : 8}
        parse={`h:52 w:100% d:flex a:center br:5 pl:16 pr:16`}
        color={active || hover ? "#2D3542" : "transparent"}
      >
        <Box>
          <Rule display="block" color="var(--font1)" rule="ls">
            {label}
          </Rule>
        </Box>
      </Box>
    </a>
  );
};

export const LegalMenuDesktop = () => {
  const router = useRouter();
  const items = [...ITEMS];
  const { documents } = useCMSDocument({});
  const region = useServerRegion();
  const _documents = documents.filter((item) =>
    item.regionTags?.includes(String(region?.id))
  );

  return (
    <Box css="br:10" parse="c:?foreground pa:10">
      {items.map((item, i) => (
        <LegalMenuPlainItem
          key={item.slug}
          i={i}
          label={item.label}
          href={`/legal/${item.slug}`}
          active={router.pathname.includes(item.slug)}
        />
      ))}
      {_documents.map((item, i) => (
        <LegalMenuPlainItem
          key={item.slug}
          i={i}
          label={item.name}
          href={`/legal/documents/${item.slug}`}
          active={router.pathname.includes(item.slug)}
        />
      ))}
    </Box>
  );
};

export default LegalMenuDesktop;
